// sw.js
/* global ZIEGE_VERSION */

const PUSH_BACKEND_URL = "https://admin.ziege.social";

// Nur Pushs an Konten mit dem Feature push-debug tragen "debug" ({bezug, pushkey});
// der Service Worker meldet dazu Empfang, Anzeige und Klick ans Push-Protokoll.
function debugMelden(debug, art, daten = {}) {
    if (!debug || typeof debug.pushkey !== "string") {
        return Promise.resolve();
    }
    return fetch(`${PUSH_BACKEND_URL}/v1/push/${encodeURIComponent(debug.pushkey)}/debug`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({art, bezug: debug.bezug, sw_version: ZIEGE_VERSION, zeit: new Date().toISOString(), daten}),
    }).catch((e) => console.warn("Push-Protokoll nicht erreicht: ", e));
}

// Die App fragt so, welche Version des Service Workers läuft.
self.addEventListener('message', (event) => {
    if (event.data?.type === "version" && event.ports[0]) {
        event.ports[0].postMessage({version: ZIEGE_VERSION});
    }
});
self.addEventListener('install', event => {
    console.log('Service Worker installiert');
    self.skipWaiting();
});

self.addEventListener('activate', event => {
    console.log('Service Worker aktiviert');
});

self.addEventListener('fetch', event => {
    // Noch keine Caching-Strategie, einfach durchreichen
});

// Browser beenden den Service Worker, sobald der Handler zurückkehrt; die
// Notification muss daher innerhalb von event.waitUntil() angezeigt werden.
// Safari kündigt das Push-Abo, wenn ein Push ohne Notification endet; fehlt der Text
// im Push, erscheint deshalb der übliche.
self.addEventListener('push', (event) => {
    console.log('Push event received', event)

    let payload = {};
    try {
        payload = event.data?.json() ?? {};
    } catch (e) {
        console.warn("Push ohne lesbaren Inhalt: ", e);
    }

    const title = typeof payload.title === "string" && payload.title ? payload.title : "Drück die Ziege!";
    const body = typeof payload.body === "string" && payload.body ? payload.body : "Die Ziege braucht Aufmerksamkeit! Schau mal!";

    const debug = payload.debug;
    const empfangen = debugMelden(debug, "empfangen");

    event.waitUntil((async () => {
        try {
            await self.registration.showNotification(title, {
                body,
                icon: "static/appicon.png",
                vibrate: [200, 100, 200, 100, 200, 100, 200],
                tag: "drueck-die-ziege",
                data: {debug},
            });
            await debugMelden(debug, "angezeigt");
        } catch (e) {
            await debugMelden(debug, "anzeige_fehlgeschlagen", {fehler: String(e)});
            throw e;
        } finally {
            await empfangen;
        }
    })());
});

self.addEventListener('notificationclick', (event) => {
    event.notification.close();
    const geklickt = debugMelden(event.notification.data?.debug, "geklickt");

    // Fokus und neues Fenster sind nur unmittelbar nach dem Klick erlaubt; die
    // Meldung läuft daneben.
    event.waitUntil(Promise.all([geklickt,
        clients.matchAll({ type: 'window', includeUncontrolled: true }).then((clientList) => {
            for (const client of clientList) {
                if (client.url === '/' || client.url.includes('ziege.html')) {
                    return client.focus();
                }
            }
            if (clients.openWindow) {
                return clients.openWindow('/ziege/ziege.html');
            }
        }),
    ]));
});



